var items = {
  "block.minecraft.air": "aire",
  "block.minecraft.stone": "piedra",
  "block.minecraft.granite": "granito",
  "block.minecraft.polished_granite": "granito pulido",
  "block.minecraft.diorite": "diorita",
  "block.minecraft.polished_diorite": "diorita pulida",
  "block.minecraft.andesite": "andesita",
  "block.minecraft.polished_andesite": "andesita pulida",
  "block.minecraft.grass_block": "césped",
  "block.minecraft.dirt": "tierra",
  "block.minecraft.coarse_dirt": "tierra estéril",
  "block.minecraft.podzol": "podsol",
  "block.minecraft.crimson_nylium": "necelio carmesí",
  "block.minecraft.warped_nylium": "necelio distorsionado",
  "block.minecraft.cobblestone": "roca",
  "block.minecraft.oak_planks": "tablones de roble",
  "block.minecraft.spruce_planks": "tablones de abeto",
  "block.minecraft.birch_planks": "tablones de abedul",
  "block.minecraft.jungle_planks": "tablones de jungla",
  "block.minecraft.acacia_planks": "tablones de acacia",
  "block.minecraft.dark_oak_planks": "tablones de roble oscuro",
  "block.minecraft.crimson_planks": "tablones carmesí",
  "block.minecraft.warped_planks": "tablones distorsionados",
  "block.minecraft.oak_sapling": "brote de roble",
  "block.minecraft.spruce_sapling": "brote de abeto",
  "block.minecraft.birch_sapling": "brote de abedul",
  "block.minecraft.jungle_sapling": "brote de jungla",
  "block.minecraft.acacia_sapling": "brote de acacia",
  "block.minecraft.dark_oak_sapling": "brote de roble oscuro",
  "block.minecraft.bedrock": "piedra base",
  "block.minecraft.sand": "arena",
  "block.minecraft.red_sand": "arena roja",
  "block.minecraft.gravel": "grava",
  "block.minecraft.gold_ore": "mena de oro",
  "block.minecraft.iron_ore": "mena de hierro",
  "block.minecraft.coal_ore": "mena de carbón",
  "block.minecraft.nether_gold_ore": "mena de oro del nether",
  "block.minecraft.oak_log": "tronco de roble",
  "block.minecraft.spruce_log": "tronco de abeto",
  "block.minecraft.birch_log": "tronco de abedul",
  "block.minecraft.jungle_log": "tronco de jungla",
  "block.minecraft.acacia_log": "tronco de acacia",
  "block.minecraft.dark_oak_log": "tronco de roble oscuro",
  "block.minecraft.crimson_stem": "tallo carmesí",
  "block.minecraft.warped_stem": "tallo distorsionado",
  "block.minecraft.stripped_oak_log": "tronco de roble sin corteza",
  "block.minecraft.stripped_spruce_log": "tronco de abeto sin corteza",
  "block.minecraft.stripped_birch_log": "tronco de abedul sin corteza",
  "block.minecraft.stripped_jungle_log": "tronco de jungla sin corteza",
  "block.minecraft.stripped_acacia_log": "tronco de acacia sin corteza",
  "block.minecraft.stripped_dark_oak_log": "tronco de roble oscuro sin corteza",
  "block.minecraft.stripped_crimson_stem": "tallo carmesí sin corteza",
  "block.minecraft.stripped_warped_stem": "tallo distorsionado sin corteza",
  "block.minecraft.stripped_oak_wood": "leño de roble sin corteza",
  "block.minecraft.stripped_spruce_wood": "leño de abeto sin corteza",
  "block.minecraft.stripped_birch_wood": "leño de abedul sin corteza",
  "block.minecraft.stripped_jungle_wood": "leño de jungla sin corteza",
  "block.minecraft.stripped_acacia_wood": "leño de acacia sin corteza",
  "block.minecraft.stripped_dark_oak_wood": "leño de roble oscuro sin corteza",
  "block.minecraft.stripped_crimson_hyphae": "hifas carmesí sin corteza",
  "block.minecraft.stripped_warped_hyphae": "hifas distorsionadas sin corteza",
  "block.minecraft.oak_wood": "leño de roble",
  "block.minecraft.spruce_wood": "leño de abeto",
  "block.minecraft.birch_wood": "leño de abedul",
  "block.minecraft.jungle_wood": "leño de jungla",
  "block.minecraft.acacia_wood": "leño de acacia",
  "block.minecraft.dark_oak_wood": "leño de roble oscuro",
  "block.minecraft.crimson_hyphae": "hifas carmesí",
  "block.minecraft.warped_hyphae": "hifas distorsionadas",
  "block.minecraft.oak_leaves": "hojas de roble",
  "block.minecraft.spruce_leaves": "hojas de abeto",
  "block.minecraft.birch_leaves": "hojas de abedul",
  "block.minecraft.jungle_leaves": "hojas de jungla",
  "block.minecraft.acacia_leaves": "hojas de acacia",
  "block.minecraft.dark_oak_leaves": "hojas de roble oscuro",
  "block.minecraft.sponge": "esponja",
  "block.minecraft.wet_sponge": "esponja mojada",
  "block.minecraft.glass": "cristal",
  "block.minecraft.lapis_ore": "mena de lapislázuli",
  "block.minecraft.lapis_block": "bloque de lapislázuli",
  "block.minecraft.dispenser": "dispensador",
  "block.minecraft.sandstone": "arenisca",
  "block.minecraft.chiseled_sandstone": "arenisca cincelada",
  "block.minecraft.cut_sandstone": "arenisca cortada",
  "block.minecraft.note_block": "bloque musical",
  "block.minecraft.powered_rail": "raíl propulsor",
  "block.minecraft.detector_rail": "raíl detector",
  "block.minecraft.sticky_piston": "pistón pegajoso",
  "block.minecraft.cobweb": "telaraña",
  "block.minecraft.grass": "hierba",
  "block.minecraft.fern": "helecho",
  "block.minecraft.dead_bush": "arbusto muerto",
  "block.minecraft.seagrass": "hierba marina",
  "block.minecraft.sea_pickle": "pepino de mar",
  "block.minecraft.piston": "pistón",
  "block.minecraft.white_wool": "lana blanca",
  "block.minecraft.orange_wool": "lana naranja",
  "block.minecraft.magenta_wool": "lana magenta",
  "block.minecraft.light_blue_wool": "lana azul claro",
  "block.minecraft.yellow_wool": "lana amarilla",
  "block.minecraft.lime_wool": "lana lima",
  "block.minecraft.pink_wool": "lana rosa",
  "block.minecraft.gray_wool": "lana gris",
  "block.minecraft.light_gray_wool": "lana gris claro",
  "block.minecraft.cyan_wool": "lana cian",
  "block.minecraft.purple_wool": "lana lila",
  "block.minecraft.blue_wool": "lana azul",
  "block.minecraft.brown_wool": "lana marrón",
  "block.minecraft.green_wool": "lana verde",
  "block.minecraft.red_wool": "lana roja",
  "block.minecraft.black_wool": "lana negra",
  "block.minecraft.dandelion": "diente de león",
  "block.minecraft.poppy": "amapola",
  "block.minecraft.blue_orchid": "orquídea azul",
  "block.minecraft.allium": "allium",
  "block.minecraft.azure_bluet": "azure bluet",
  "block.minecraft.red_tulip": "tulipán rojo",
  "block.minecraft.orange_tulip": "tulipán naranja",
  "block.minecraft.white_tulip": "tulipán blanco",
  "block.minecraft.pink_tulip": "tulipán rosa",
  "block.minecraft.oxeye_daisy": "margarita",
  "block.minecraft.cornflower": "aciano",
  "block.minecraft.lily_of_the_valley": "convalaria",
  "block.minecraft.wither_rose": "rosa de wither",
  "block.minecraft.brown_mushroom": "champiñón marrón",
  "block.minecraft.red_mushroom": "champiñón rojo",
  "block.minecraft.crimson_fungus": "hongo carmesí",
  "block.minecraft.warped_fungus": "hongo distorsionado",
  "block.minecraft.crimson_roots": "raíces carmesí",
  "block.minecraft.warped_roots": "raíces distorsionadas",
  "block.minecraft.nether_sprouts": "rastrojo del nether",
  "block.minecraft.weeping_vines": "enredaderas lacrimosas",
  "block.minecraft.twisting_vines": "enredaderas retorcidas",
  "block.minecraft.sugar_cane": "caña de azúcar",
  "block.minecraft.kelp": "alga",
  "block.minecraft.bamboo": "bambú",
  "block.minecraft.gold_block": "bloque de oro",
  "block.minecraft.iron_block": "bloque de hierro",
  "block.minecraft.oak_slab": "losa de roble",
  "block.minecraft.spruce_slab": "losa de abeto",
  "block.minecraft.birch_slab": "losa de abedul",
  "block.minecraft.jungle_slab": "losa de jungla",
  "block.minecraft.acacia_slab": "losa de acacia",
  "block.minecraft.dark_oak_slab": "losa de roble oscuro",
  "block.minecraft.crimson_slab": "losa carmesí",
  "block.minecraft.warped_slab": "losa distorsionada",
  "block.minecraft.stone_slab": "losa de piedra",
  "block.minecraft.smooth_stone_slab": "losa de piedra lisa",
  "block.minecraft.sandstone_slab": "losa de arenisca",
  "block.minecraft.cut_sandstone_slab": "losa de arenisca cortada",
  "block.minecraft.petrified_oak_slab": "losa de roble petrificada",
  "block.minecraft.cobblestone_slab": "losa de roca",
  "block.minecraft.brick_slab": "losa de ladrillos",
  "block.minecraft.stone_brick_slab": "losa de ladrillos de piedra",
  "block.minecraft.nether_brick_slab": "losa de ladrillos del nether",
  "block.minecraft.quartz_slab": "losa de cuarzo",
  "block.minecraft.red_sandstone_slab": "losa de arenisca roja",
  "block.minecraft.cut_red_sandstone_slab": "losa de arenisca roja cortada",
  "block.minecraft.purpur_slab": "losa de púrpur",
  "block.minecraft.prismarine_slab": "losa de prismarina",
  "block.minecraft.prismarine_brick_slab": "losa de ladrillos de prismarina",
  "block.minecraft.dark_prismarine_slab": "losa de prismarina oscura",
  "block.minecraft.smooth_quartz": "bloque de cuarzo liso",
  "block.minecraft.smooth_red_sandstone": "arenisca roja lisa",
  "block.minecraft.smooth_sandstone": "arenisca lisa",
  "block.minecraft.smooth_stone": "piedra lisa",
  "block.minecraft.bricks": "ladrillos",
  "block.minecraft.tnt": "dinamita",
  "block.minecraft.bookshelf": "librería",
  "block.minecraft.mossy_cobblestone": "roca musgosa",
  "block.minecraft.obsidian": "obsidiana",
  "block.minecraft.torch": "antorcha",
  "block.minecraft.end_rod": "vara del end",
  "block.minecraft.chorus_plant": "planta coral",
  "block.minecraft.chorus_flower": "flor coral",
  "block.minecraft.purpur_block": "bloque de púrpur",
  "block.minecraft.purpur_pillar": "pilar de púrpur",
  "block.minecraft.purpur_stairs": "escaleras de púrpur",
  "block.minecraft.spawner": "generador",
  "block.minecraft.oak_stairs": "escaleras de roble",
  "block.minecraft.chest": "cofre",
  "block.minecraft.diamond_ore": "mena de diamante",
  "block.minecraft.diamond_block": "bloque de diamante",
  "block.minecraft.crafting_table": "mesa de trabajo",
  "block.minecraft.farmland": "tierra de cultivo",
  "block.minecraft.furnace": "horno",
  "block.minecraft.ladder": "escalera de mano",
  "block.minecraft.rail": "raíl",
  "block.minecraft.cobblestone_stairs": "escaleras de roca",
  "block.minecraft.lever": "palanca",
  "block.minecraft.stone_pressure_plate": "placa de presión de piedra",
  "block.minecraft.oak_pressure_plate": "placa de presión de roble",
  "block.minecraft.spruce_pressure_plate": "placa de presión de abeto",
  "block.minecraft.birch_pressure_plate": "placa de presión de abedul",
  "block.minecraft.jungle_pressure_plate": "placa de presión de jungla",
  "block.minecraft.acacia_pressure_plate": "placa de presión de acacia",
  "block.minecraft.dark_oak_pressure_plate": "placa de presión de roble oscuro",
  "block.minecraft.crimson_pressure_plate": "placa de presión carmesí",
  "block.minecraft.warped_pressure_plate": "placa de presión distorsionada",
  "block.minecraft.polished_blackstone_pressure_plate": "placa de presión de piedra negra pulida",
  "block.minecraft.redstone_ore": "mena de redstone",
  "block.minecraft.redstone_torch": "antorcha de redstone",
  "block.minecraft.snow": "capa de nieve",
  "block.minecraft.ice": "hielo",
  "block.minecraft.snow_block": "bloque de nieve",
  "block.minecraft.cactus": "cactus",
  "block.minecraft.clay": "bloque de arcilla",
  "block.minecraft.jukebox": "tocadiscos",
  "block.minecraft.oak_fence": "valla de roble",
  "block.minecraft.spruce_fence": "valla de abeto",
  "block.minecraft.birch_fence": "valla de abedul",
  "block.minecraft.jungle_fence": "valla de jungla",
  "block.minecraft.acacia_fence": "valla de acacia",
  "block.minecraft.dark_oak_fence": "valla de roble oscuro",
  "block.minecraft.crimson_fence": "valla de madera carmesí",
  "block.minecraft.warped_fence": "valla distorsionada",
  "block.minecraft.pumpkin": "calabaza",
  "block.minecraft.carved_pumpkin": "calabaza tallada",
  "block.minecraft.netherrack": "netherrack",
  "block.minecraft.soul_sand": "arena de almas",
  "block.minecraft.soul_soil": "tierra de almas",
  "block.minecraft.basalt": "basalto",
  "block.minecraft.polished_basalt": "basalto pulido",
  "block.minecraft.soul_torch": "antorcha de almas",
  "block.minecraft.glowstone": "piedra luminosa",
  "block.minecraft.jack_o_lantern": "calabaza de halloween",
  "block.minecraft.oak_trapdoor": "trampilla de roble",
  "block.minecraft.spruce_trapdoor": "trampilla de abeto",
  "block.minecraft.birch_trapdoor": "trampilla de abedul",
  "block.minecraft.jungle_trapdoor": "trampilla de jungla",
  "block.minecraft.acacia_trapdoor": "trampilla de acacia",
  "block.minecraft.dark_oak_trapdoor": "trampilla de roble oscuro",
  "block.minecraft.crimson_trapdoor": "trampilla carmesí",
  "block.minecraft.warped_trapdoor": "trampilla distorsionada",
  "block.minecraft.infested_stone": "piedra infestada",
  "block.minecraft.infested_cobblestone": "roca infestada",
  "block.minecraft.infested_stone_bricks": "ladrillos de piedra infestados",
  "block.minecraft.infested_mossy_stone_bricks": "ladrillos de piedra musgosos infestados",
  "block.minecraft.infested_cracked_stone_bricks": "ladrillos de piedra agrietados infestados",
  "block.minecraft.infested_chiseled_stone_bricks": "ladrillos de piedra cincelados infestados",
  "block.minecraft.stone_bricks": "ladrillos de piedra",
  "block.minecraft.mossy_stone_bricks": "ladrillos de piedra musgosos",
  "block.minecraft.cracked_stone_bricks": "ladrillos de piedra agrietados",
  "block.minecraft.chiseled_stone_bricks": "ladrillos de piedra cincelados",
  "block.minecraft.brown_mushroom_block": "bloque de champiñón marrón",
  "block.minecraft.red_mushroom_block": "bloque de champiñón rojo",
  "block.minecraft.mushroom_stem": "tallo de champiñón",
  "block.minecraft.iron_bars": "barrotes de hierro",
  "block.minecraft.chain": "cadena",
  "block.minecraft.glass_pane": "panel de cristal",
  "block.minecraft.melon": "sandía",
  "block.minecraft.vine": "enredadera",
  "block.minecraft.oak_fence_gate": "puerta de valla de roble",
  "block.minecraft.spruce_fence_gate": "puerta de valla de abeto",
  "block.minecraft.birch_fence_gate": "puerta de valla de abedul",
  "block.minecraft.jungle_fence_gate": "puerta de valla de jungla",
  "block.minecraft.acacia_fence_gate": "puerta de valla de acacia",
  "block.minecraft.dark_oak_fence_gate": "puerta de valla de roble oscuro",
  "block.minecraft.crimson_fence_gate": "puerta de valla carmesí",
  "block.minecraft.warped_fence_gate": "puerta de valla distorsionada",
  "block.minecraft.brick_stairs": "escaleras de ladrillos",
  "block.minecraft.stone_brick_stairs": "escaleras de ladrillos de piedra",
  "block.minecraft.mycelium": "micelio",
  "block.minecraft.lily_pad": "nenúfar",
  "block.minecraft.nether_bricks": "ladrillos del nether",
  "block.minecraft.cracked_nether_bricks": "ladrillos del nether agrietados",
  "block.minecraft.chiseled_nether_bricks": "ladrillos del nether cincelados",
  "block.minecraft.nether_brick_fence": "valla de ladrillos del nether",
  "block.minecraft.nether_brick_stairs": "escaleras de ladrillos del nether",
  "block.minecraft.enchanting_table": "mesa de encantamientos",
  "block.minecraft.end_portal_frame": "marco del portal del end",
  "block.minecraft.end_stone": "piedra del end",
  "block.minecraft.end_stone_bricks": "ladrillos de piedra del end",
  "block.minecraft.dragon_egg": "huevo de dragón",
  "block.minecraft.redstone_lamp": "lámpara de redstone",
  "block.minecraft.sandstone_stairs": "escaleras de arenisca",
  "block.minecraft.emerald_ore": "mena de esmeralda",
  "block.minecraft.ender_chest": "cofre de ender",
  "block.minecraft.tripwire_hook": "gancho de cuerda",
  "block.minecraft.emerald_block": "bloque de esmeralda",
  "block.minecraft.spruce_stairs": "escaleras de abeto",
  "block.minecraft.birch_stairs": "escaleras de abedul",
  "block.minecraft.jungle_stairs": "escaleras de jungla",
  "block.minecraft.crimson_stairs": "escaleras carmesí",
  "block.minecraft.warped_stairs": "escaleras distorsionadas",
  "block.minecraft.command_block": "bloque de comandos",
  "block.minecraft.beacon": "faro",
  "block.minecraft.cobblestone_wall": "muro de roca",
  "block.minecraft.mossy_cobblestone_wall": "muro de roca musgosa",
  "block.minecraft.brick_wall": "muro de ladrillos",
  "block.minecraft.prismarine_wall": "muro de prismarina",
  "block.minecraft.red_sandstone_wall": "muro de arenisca roja",
  "block.minecraft.mossy_stone_brick_wall": "muro de ladrillos de piedra musgosos",
  "block.minecraft.granite_wall": "muro de granito",
  "block.minecraft.stone_brick_wall": "muro de ladrillos de piedra",
  "block.minecraft.nether_brick_wall": "muro de ladrillos del nether",
  "block.minecraft.andesite_wall": "muro de andesita",
  "block.minecraft.red_nether_brick_wall": "muro de ladrillos del nether rojos",
  "block.minecraft.sandstone_wall": "muro de arenisca",
  "block.minecraft.end_stone_brick_wall": "muro de ladrillos de piedra del end",
  "block.minecraft.diorite_wall": "muro de diorita",
  "block.minecraft.blackstone_wall": "muro de piedra negra",
  "block.minecraft.polished_blackstone_wall": "muro de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_wall": "muro de ladrillos de piedra negra pulida",
  "block.minecraft.stone_button": "botón de piedra",
  "block.minecraft.oak_button": "botón de roble",
  "block.minecraft.spruce_button": "botón de abeto",
  "block.minecraft.birch_button": "botón de abedul",
  "block.minecraft.jungle_button": "botón de jungla",
  "block.minecraft.acacia_button": "botón de acacia",
  "block.minecraft.dark_oak_button": "botón de roble oscuro",
  "block.minecraft.crimson_button": "botón carmesí",
  "block.minecraft.warped_button": "botón distorsionado",
  "block.minecraft.polished_blackstone_button": "botón de piedra negra pulida",
  "block.minecraft.anvil": "yunque",
  "block.minecraft.chipped_anvil": "yunque dañado",
  "block.minecraft.damaged_anvil": "yunque muy dañado",
  "block.minecraft.trapped_chest": "cofre trampa",
  "block.minecraft.light_weighted_pressure_plate": "placa de presión para peso ligero",
  "block.minecraft.heavy_weighted_pressure_plate": "placa de presión para peso elevado",
  "block.minecraft.daylight_detector": "sensor de luz solar",
  "block.minecraft.redstone_block": "bloque de redstone",
  "block.minecraft.nether_quartz_ore": "mena de cuarzo del nether",
  "block.minecraft.hopper": "tolva",
  "block.minecraft.chiseled_quartz_block": "cuarzo cincelado",
  "block.minecraft.quartz_block": "cuarzo",
  "block.minecraft.quartz_bricks": "ladrillos de cuarzo",
  "block.minecraft.quartz_pillar": "pilar de cuarzo",
  "block.minecraft.quartz_stairs": "escaleras de cuarzo",
  "block.minecraft.activator_rail": "raíl activador",
  "block.minecraft.dropper": "soltador",
  "block.minecraft.white_terracotta": "terracota blanca",
  "block.minecraft.orange_terracotta": "terracota naranja",
  "block.minecraft.magenta_terracotta": "terracota magenta",
  "block.minecraft.light_blue_terracotta": "terracota azul claro",
  "block.minecraft.yellow_terracotta": "terracota amarilla",
  "block.minecraft.lime_terracotta": "terracota verde lima",
  "block.minecraft.pink_terracotta": "terracota rosa",
  "block.minecraft.gray_terracotta": "terracota gris",
  "block.minecraft.light_gray_terracotta": "terracota gris claro",
  "block.minecraft.cyan_terracotta": "terracota cian",
  "block.minecraft.purple_terracotta": "terracota morada",
  "block.minecraft.blue_terracotta": "terracota azul",
  "block.minecraft.brown_terracotta": "terracota marrón",
  "block.minecraft.green_terracotta": "terracota verde",
  "block.minecraft.red_terracotta": "terracota roja",
  "block.minecraft.black_terracotta": "terracota negra",
  "block.minecraft.barrier": "barrera",
  "block.minecraft.iron_trapdoor": "trampilla de hierro",
  "block.minecraft.hay_block": "bala de heno",
  "block.minecraft.white_carpet": "alfombra blanca",
  "block.minecraft.orange_carpet": "alfombra naranja",
  "block.minecraft.magenta_carpet": "alfombra magenta",
  "block.minecraft.light_blue_carpet": "alfombra azul claro",
  "block.minecraft.yellow_carpet": "alfombra amarilla",
  "block.minecraft.lime_carpet": "alfombra verde lima",
  "block.minecraft.pink_carpet": "alfombra rosa",
  "block.minecraft.gray_carpet": "alfombra gris",
  "block.minecraft.light_gray_carpet": "alfombra gris claro",
  "block.minecraft.cyan_carpet": "alfombra cian",
  "block.minecraft.purple_carpet": "alfombra lila",
  "block.minecraft.blue_carpet": "alfombra azul",
  "block.minecraft.brown_carpet": "alfombra marrón",
  "block.minecraft.green_carpet": "alfombra verde",
  "block.minecraft.red_carpet": "alfombra roja",
  "block.minecraft.black_carpet": "alfombra negra",
  "block.minecraft.terracotta": "terracota",
  "block.minecraft.coal_block": "bloque de carbón",
  "block.minecraft.packed_ice": "hielo compacto",
  "block.minecraft.acacia_stairs": "escaleras de acacia",
  "block.minecraft.dark_oak_stairs": "escaleras de roble oscuro",
  "block.minecraft.slime_block": "bloque de slime",
  "block.minecraft.grass_path": "camino de césped",
  "block.minecraft.sunflower": "girasol",
  "block.minecraft.lilac": "lila",
  "block.minecraft.rose_bush": "rosal",
  "block.minecraft.peony": "peonía",
  "block.minecraft.tall_grass": "hierba alta",
  "block.minecraft.large_fern": "helecho grande",
  "block.minecraft.white_stained_glass": "cristal tintado de blanco",
  "block.minecraft.orange_stained_glass": "cristal tintado de naranja",
  "block.minecraft.magenta_stained_glass": "cristal tintado de magenta",
  "block.minecraft.light_blue_stained_glass": "cristal tintado de azul claro",
  "block.minecraft.yellow_stained_glass": "cristal tintado de amarillo",
  "block.minecraft.lime_stained_glass": "cristal tintado de verde lima",
  "block.minecraft.pink_stained_glass": "cristal tintado de rosa",
  "block.minecraft.gray_stained_glass": "cristal tintado de gris",
  "block.minecraft.light_gray_stained_glass": "cristal tintado de gris claro",
  "block.minecraft.cyan_stained_glass": "cristal tintado de cian",
  "block.minecraft.purple_stained_glass": "cristal tintado de morado",
  "block.minecraft.blue_stained_glass": "cristal tintado de azul",
  "block.minecraft.brown_stained_glass": "cristal tintado de marrón",
  "block.minecraft.green_stained_glass": "cristal tintado de verde",
  "block.minecraft.red_stained_glass": "cristal tintado de rojo",
  "block.minecraft.black_stained_glass": "cristal tintado de negro",
  "block.minecraft.white_stained_glass_pane": "panel de cristal tintado de blanco",
  "block.minecraft.orange_stained_glass_pane": "panel de cristal tintado de naranja",
  "block.minecraft.magenta_stained_glass_pane": "panel de cristal tintado de magenta",
  "block.minecraft.light_blue_stained_glass_pane": "panel de cristal tintado de azul claro",
  "block.minecraft.yellow_stained_glass_pane": "panel de cristal tintado de amarillo",
  "block.minecraft.lime_stained_glass_pane": "panel de cristal tintado de verde lima",
  "block.minecraft.pink_stained_glass_pane": "panel de cristal tintado de rosa",
  "block.minecraft.gray_stained_glass_pane": "panel de cristal tintado de gris",
  "block.minecraft.light_gray_stained_glass_pane": "panel de cristal tintado de gris claro",
  "block.minecraft.cyan_stained_glass_pane": "panel de cristal tintado de cian",
  "block.minecraft.purple_stained_glass_pane": "panel de cristal tintado de morado",
  "block.minecraft.blue_stained_glass_pane": "panel de cristal tintado de azul",
  "block.minecraft.brown_stained_glass_pane": "panel de cristal tintado de marrón",
  "block.minecraft.green_stained_glass_pane": "panel de cristal tintado de verde",
  "block.minecraft.red_stained_glass_pane": "panel de cristal tintado de rojo",
  "block.minecraft.black_stained_glass_pane": "panel de cristal tintado de negro",
  "block.minecraft.prismarine": "prismarina",
  "block.minecraft.prismarine_bricks": "ladrillos de prismarina",
  "block.minecraft.dark_prismarine": "prismarina oscura",
  "block.minecraft.prismarine_stairs": "escaleras de prismarina",
  "block.minecraft.prismarine_brick_stairs": "escaleras de ladrillos de prismarina",
  "block.minecraft.dark_prismarine_stairs": "escaleras de prismarina oscura",
  "block.minecraft.sea_lantern": "linterna marina",
  "block.minecraft.red_sandstone": "arenisca roja",
  "block.minecraft.chiseled_red_sandstone": "arenisca roja cincelada",
  "block.minecraft.cut_red_sandstone": "arenisca roja cortada",
  "block.minecraft.red_sandstone_stairs": "escaleras de arenisca roja",
  "block.minecraft.repeating_command_block": "bloque de comando de repetición",
  "block.minecraft.chain_command_block": "bloque de comandos en cadena",
  "block.minecraft.magma_block": "bloque de magma",
  "block.minecraft.nether_wart_block": "bloque de verrugas del nether",
  "block.minecraft.warped_wart_block": "bloque de verrugas distorsionadas",
  "block.minecraft.red_nether_bricks": "ladrillos del nether rojos",
  "block.minecraft.bone_block": "bloque de huesos",
  "block.minecraft.structure_void": "vacío estructural",
  "block.minecraft.observer": "observador",
  "block.minecraft.shulker_box": "caja de shulker",
  "block.minecraft.white_shulker_box": "caja de shulker blanca",
  "block.minecraft.orange_shulker_box": "caja de shulker naranja",
  "block.minecraft.magenta_shulker_box": "caja de shulker magenta",
  "block.minecraft.light_blue_shulker_box": "caja de shulker azul claro",
  "block.minecraft.yellow_shulker_box": "caja de shulker amarilla",
  "block.minecraft.lime_shulker_box": "caja de shulker verde lima",
  "block.minecraft.pink_shulker_box": "caja de shulker rosa",
  "block.minecraft.gray_shulker_box": "caja de shulker gris",
  "block.minecraft.light_gray_shulker_box": "caja de shulker gris claro",
  "block.minecraft.cyan_shulker_box": "caja de shulker cian",
  "block.minecraft.purple_shulker_box": "caja de shulker morada",
  "block.minecraft.blue_shulker_box": "caja de shulker azul",
  "block.minecraft.brown_shulker_box": "caja de shulker marrón",
  "block.minecraft.green_shulker_box": "caja de shulker verde",
  "block.minecraft.red_shulker_box": "caja de shulker roja",
  "block.minecraft.black_shulker_box": "caja de shulker negra",
  "block.minecraft.white_glazed_terracotta": "azulejo blanco",
  "block.minecraft.orange_glazed_terracotta": "azulejo naranja",
  "block.minecraft.magenta_glazed_terracotta": "azulejo magenta",
  "block.minecraft.light_blue_glazed_terracotta": "azulejo azul claro",
  "block.minecraft.yellow_glazed_terracotta": "azulejo amarillo",
  "block.minecraft.lime_glazed_terracotta": "azulejo verde lima",
  "block.minecraft.pink_glazed_terracotta": "azulejo rosa",
  "block.minecraft.gray_glazed_terracotta": "azulejo gris",
  "block.minecraft.light_gray_glazed_terracotta": "azulejo gris claro",
  "block.minecraft.cyan_glazed_terracotta": "azulejo cian",
  "block.minecraft.purple_glazed_terracotta": "azulejo morado",
  "block.minecraft.blue_glazed_terracotta": "azulejo azul",
  "block.minecraft.brown_glazed_terracotta": "azulejo marrón",
  "block.minecraft.green_glazed_terracotta": "azulejo verde",
  "block.minecraft.red_glazed_terracotta": "azulejo rojo",
  "block.minecraft.black_glazed_terracotta": "azulejo negro",
  "block.minecraft.white_concrete": "hormigón blanco",
  "block.minecraft.orange_concrete": "hormigón naranja",
  "block.minecraft.magenta_concrete": "hormigón magenta",
  "block.minecraft.light_blue_concrete": "hormigón azul claro",
  "block.minecraft.yellow_concrete": "hormigón amarillo",
  "block.minecraft.lime_concrete": "hormigón verde lima",
  "block.minecraft.pink_concrete": "hormigón rosa",
  "block.minecraft.gray_concrete": "hormigón gris",
  "block.minecraft.light_gray_concrete": "hormigón gris claro",
  "block.minecraft.cyan_concrete": "hormigón cian",
  "block.minecraft.purple_concrete": "hormigón morado",
  "block.minecraft.blue_concrete": "hormigón azul",
  "block.minecraft.brown_concrete": "hormigón marrón",
  "block.minecraft.green_concrete": "hormigón verde",
  "block.minecraft.red_concrete": "hormigón rojo",
  "block.minecraft.black_concrete": "hormigón negro",
  "block.minecraft.white_concrete_powder": "cemento blanco",
  "block.minecraft.orange_concrete_powder": "cemento naranja",
  "block.minecraft.magenta_concrete_powder": "cemento magenta",
  "block.minecraft.light_blue_concrete_powder": "cemento azul claro",
  "block.minecraft.yellow_concrete_powder": "cemento amarillo",
  "block.minecraft.lime_concrete_powder": "cemento verde lima",
  "block.minecraft.pink_concrete_powder": "cemento rosa",
  "block.minecraft.gray_concrete_powder": "cemento gris",
  "block.minecraft.light_gray_concrete_powder": "cemento gris claro",
  "block.minecraft.cyan_concrete_powder": "cemento cian",
  "block.minecraft.purple_concrete_powder": "cemento morado",
  "block.minecraft.blue_concrete_powder": "cemento azul",
  "block.minecraft.brown_concrete_powder": "cemento marrón",
  "block.minecraft.green_concrete_powder": "cemento verde",
  "block.minecraft.red_concrete_powder": "cemento rojo",
  "block.minecraft.black_concrete_powder": "cemento negro",
  "block.minecraft.turtle_egg": "huevo de tortuga",
  "block.minecraft.dead_tube_coral_block": "bloque de coral de tubo muerto",
  "block.minecraft.dead_brain_coral_block": "bloque de coral de cerebro muerto",
  "block.minecraft.dead_bubble_coral_block": "bloque de coral de burbuja muerto",
  "block.minecraft.dead_fire_coral_block": "bloque de coral de fuego muerto",
  "block.minecraft.dead_horn_coral_block": "bloque de coral de cuerno muerto",
  "block.minecraft.tube_coral_block": "bloque de coral de tubo",
  "block.minecraft.brain_coral_block": "bloque de coral de cerebro",
  "block.minecraft.bubble_coral_block": "bloque de coral de burbuja",
  "block.minecraft.fire_coral_block": "bloque de coral de fuego",
  "block.minecraft.horn_coral_block": "bloque de coral de cuerno",
  "block.minecraft.tube_coral": "coral de tubo",
  "block.minecraft.brain_coral": "coral de cerebro",
  "block.minecraft.bubble_coral": "coral de burbuja",
  "block.minecraft.fire_coral": "coral de fuego",
  "block.minecraft.horn_coral": "coral de cuerno",
  "block.minecraft.dead_brain_coral": "coral de cerebro muerto",
  "block.minecraft.dead_bubble_coral": "coral de burbuja muerto",
  "block.minecraft.dead_fire_coral": "coral de fuego muerto",
  "block.minecraft.dead_horn_coral": "coral de cuerno muerto",
  "block.minecraft.dead_tube_coral": "coral de tubo muerto",
  "block.minecraft.tube_coral_fan": "gorgonia de tubo",
  "block.minecraft.brain_coral_fan": "gorgonia de cerebro",
  "block.minecraft.bubble_coral_fan": "gorgonia de burbuja",
  "block.minecraft.fire_coral_fan": "gorgonia de fuego",
  "block.minecraft.horn_coral_fan": "gorgonia de cuerno",
  "block.minecraft.dead_tube_coral_fan": "gorgonia de tubo muerta",
  "block.minecraft.dead_brain_coral_fan": "gorgonia de cerebro muerta",
  "block.minecraft.dead_bubble_coral_fan": "gorgonia de burbuja muerta",
  "block.minecraft.dead_fire_coral_fan": "gorgonia de fuego muerta",
  "block.minecraft.dead_horn_coral_fan": "gorgonia de cuerno muerta",
  "block.minecraft.blue_ice": "hielo azul",
  "block.minecraft.conduit": "canalizador",
  "block.minecraft.polished_granite_stairs": "escaleras de granito pulido",
  "block.minecraft.smooth_red_sandstone_stairs": "escaleras de arenisca roja lisa",
  "block.minecraft.mossy_stone_brick_stairs": "escaleras de ladrillos de piedra musgosos",
  "block.minecraft.polished_diorite_stairs": "escaleras de diorita pulida",
  "block.minecraft.mossy_cobblestone_stairs": "escaleras de roca musgosa",
  "block.minecraft.end_stone_brick_stairs": "escaleras de ladrillos de piedra del end",
  "block.minecraft.stone_stairs": "escaleras de piedra",
  "block.minecraft.smooth_sandstone_stairs": "escaleras de arenisca lisa",
  "block.minecraft.smooth_quartz_stairs": "escaleras de cuarzo liso",
  "block.minecraft.granite_stairs": "escaleras de granito",
  "block.minecraft.andesite_stairs": "escaleras de andesita",
  "block.minecraft.red_nether_brick_stairs": "escaleras de ladrillos del nether rojos",
  "block.minecraft.polished_andesite_stairs": "escaleras de andesita pulida",
  "block.minecraft.diorite_stairs": "escaleras de diorita",
  "block.minecraft.polished_granite_slab": "losa de granito pulido",
  "block.minecraft.smooth_red_sandstone_slab": "losa de arenisca roja lisa",
  "block.minecraft.mossy_stone_brick_slab": "losa de ladrillos de piedra musgosos",
  "block.minecraft.polished_diorite_slab": "losa de diorita pulida",
  "block.minecraft.mossy_cobblestone_slab": "losa de roca musgosa",
  "block.minecraft.end_stone_brick_slab": "losa de ladrillos de piedra del end",
  "block.minecraft.smooth_sandstone_slab": "losa de arenisca lisa",
  "block.minecraft.smooth_quartz_slab": "losa de cuarzo liso",
  "block.minecraft.granite_slab": "losa de granito",
  "block.minecraft.andesite_slab": "losa de andesita",
  "block.minecraft.red_nether_brick_slab": "losa de ladrillos del nether rojos",
  "block.minecraft.polished_andesite_slab": "losa de andesita pulida",
  "block.minecraft.diorite_slab": "losa de diorita",
  "block.minecraft.scaffolding": "andamio",
  "block.minecraft.iron_door": "puerta de hierro",
  "block.minecraft.oak_door": "puerta de roble",
  "block.minecraft.spruce_door": "puerta de abeto",
  "block.minecraft.birch_door": "puerta de abedul",
  "block.minecraft.jungle_door": "puerta de jungla",
  "block.minecraft.acacia_door": "puerta de acacia",
  "block.minecraft.dark_oak_door": "puerta de roble oscuro",
  "block.minecraft.crimson_door": "puerta carmesí",
  "block.minecraft.warped_door": "puerta distorsionada",
  "block.minecraft.repeater": "repetidor de redstone",
  "block.minecraft.comparator": "comparador de redstone",
  "block.minecraft.structure_block": "bloque estructural",
  "block.minecraft.jigsaw": "bloque rompecabezas",
  "item.minecraft.turtle_helmet": "caparazón de tortuga□□en la cabeza:□armadura: +2",
  "item.minecraft.scute": "escama de tortuga",
  "item.minecraft.iron_shovel": "pala de hierro□□en la mano principal:□daño de ataque: +3.5□velocidad de ataque: -3",
  "item.minecraft.iron_pickaxe": "pico de hierro□□en la mano principal:□daño de ataque: +3□velocidad de ataque: -2.8",
  "item.minecraft.iron_axe": "hacha de hierro□□en la mano principal:□daño de ataque: +8□velocidad de ataque: -3.1",
  "item.minecraft.flint_and_steel": "mechero",
  "item.minecraft.apple": "manzana",
  "item.minecraft.bow": "arco",
  "item.minecraft.arrow": "flecha",
  "item.minecraft.coal": "carbón",
  "item.minecraft.charcoal": "carbón vegetal",
  "item.minecraft.diamond": "diamante",
  "item.minecraft.iron_ingot": "lingote de hierro",
  "item.minecraft.gold_ingot": "lingote de oro",
  "item.minecraft.netherite_ingot": "lingote de netherita",
  "item.minecraft.netherite_scrap": "fragmentos de netherita",
  "item.minecraft.iron_sword": "espada de hierro□□en la mano principal:□daño de ataque: +5□velocidad de ataque: -2.4",
  "item.minecraft.wooden_sword": "espada de madera□□en la mano principal:□daño de ataque: +3□velocidad de ataque: -2.4",
  "item.minecraft.wooden_shovel": "pala de madera□□en la mano principal:□daño de ataque: +1.5□velocidad de ataque: -3",
  "item.minecraft.wooden_pickaxe": "pico de madera□□en la mano principal:□daño de ataque: +1□velocidad de ataque: -2.8",
  "item.minecraft.wooden_axe": "hacha de madera□□en la mano principal:□daño de ataque: +6□velocidad de ataque: -3.2",
  "item.minecraft.stone_sword": "espada de piedra□□en la mano principal:□daño de ataque: +4□velocidad de ataque: -2.4",
  "item.minecraft.stone_shovel": "pala de piedra□□en la mano principal:□daño de ataque: +2.5□velocidad de ataque: -3",
  "item.minecraft.stone_pickaxe": "pico de piedra□□en la mano principal:□daño de ataque: +2□velocidad de ataque: -2.8",
  "item.minecraft.stone_axe": "hacha de piedra□□en la mano principal:□daño de ataque: +8□velocidad de ataque: -3.2",
  "item.minecraft.diamond_sword": "espada de diamante□□en la mano principal:□daño de ataque: +6□velocidad de ataque: -2.4",
  "item.minecraft.diamond_shovel": "pala de diamante□□en la mano principal:□daño de ataque: +4.5□velocidad de ataque: -3",
  "item.minecraft.diamond_pickaxe": "pico de diamante□□en la mano principal:□daño de ataque: +4□velocidad de ataque: -2.8",
  "item.minecraft.diamond_axe": "hacha de diamante□□en la mano principal:□daño de ataque: +8□velocidad de ataque: -3",
  "item.minecraft.stick": "palo",
  "item.minecraft.bowl": "cuenco",
  "item.minecraft.mushroom_stew": "estofado de champiñones",
  "item.minecraft.golden_sword": "espada de oro□□en la mano principal:□daño de ataque: +3□velocidad de ataque: -2.4",
  "item.minecraft.golden_shovel": "pala de oro□□en la mano principal:□daño de ataque: +1.5□velocidad de ataque: -3",
  "item.minecraft.golden_pickaxe": "pico de oro□□en la mano principal:□daño de ataque: +1□velocidad de ataque: -2.8",
  "item.minecraft.golden_axe": "hacha de oro□□en la mano principal:□daño de ataque: +6□velocidad de ataque: -3",
  "item.minecraft.netherite_sword": "espada de netherita□□en la mano principal:□daño de ataque: +7□velocidad de ataque: -2.4",
  "item.minecraft.netherite_shovel": "pala de netherita□□en la mano principal:□daño de ataque: +5.5□velocidad de ataque: -3",
  "item.minecraft.netherite_pickaxe": "pico de netherita□□en la mano principal:□daño de ataque: +5□velocidad de ataque: -2.8",
  "item.minecraft.netherite_axe": "hacha de netherita□□en la mano principal:□daño de ataque: +9□velocidad de ataque: -3",
  "item.minecraft.string": "hilo",
  "item.minecraft.feather": "pluma",
  "item.minecraft.gunpowder": "pólvora",
  "item.minecraft.wooden_hoe": "azada de madera□□en la mano principal:□velocidad de ataque: -3",
  "item.minecraft.stone_hoe": "azada de piedra□□en la mano principal:□velocidad de ataque: -2",
  "item.minecraft.iron_hoe": "azada de hierro□□en la mano principal:□velocidad de ataque: -1",
  "item.minecraft.diamond_hoe": "azada de diamante□□en la mano principal:",
  "item.minecraft.golden_hoe": "azada de oro□□en la mano principal:□velocidad de ataque: -3",
  "item.minecraft.netherite_hoe": "azada de netherita□□en la mano principal:",
  "item.minecraft.wheat_seeds": "semillas de trigo",
  "item.minecraft.wheat": "trigo",
  "item.minecraft.bread": "pan",
  "item.minecraft.leather_helmet": "sombrero de cuero□□en la cabeza:□armadura: +1",
  "item.minecraft.leather_chestplate": "túnica de cuero□□en el cuerpo:□armadura: +3",
  "item.minecraft.leather_leggings": "pantalones de cuero□□en las piernas:□armadura: +2",
  "item.minecraft.leather_boots": "botas de cuero□□en los pies:□armadura: +1",
  "item.minecraft.chainmail_helmet": "casco de cota de mallas□□en la cabeza:□armadura: +2",
  "item.minecraft.chainmail_chestplate": "peto de cota de mallas□□en el cuerpo:□armadura: +5",
  "item.minecraft.chainmail_leggings": "grebas de cota de mallas□□en las piernas:□armadura: +4",
  "item.minecraft.chainmail_boots": "botas de cota de mallas□□en los pies:□armadura: +1",
  "item.minecraft.iron_helmet": "casco de hierro□□en la cabeza:□armadura: +2",
  "item.minecraft.iron_chestplate": "peto de hierro□□en el cuerpo:□armadura: +6",
  "item.minecraft.iron_leggings": "grebas de hierro□□en las piernas:□armadura: +5",
  "item.minecraft.iron_boots": "botas de hierro□□en los pies:□armadura: +2",
  "item.minecraft.diamond_helmet": "casco de diamante□□en la cabeza:□armadura: +3□dureza de armadura: +2",
  "item.minecraft.diamond_chestplate": "peto de diamante□□en el cuerpo:□armadura: +8□dureza de armadura: +2",
  "item.minecraft.diamond_leggings": "grebas de diamante□□en las piernas:□armadura: +6□dureza de armadura: +2",
  "item.minecraft.diamond_boots": "botas de diamante□□en los pies:□armadura: +3□dureza de armadura: +2",
  "item.minecraft.golden_helmet": "casco de oro□□en la cabeza:□armadura: +2",
  "item.minecraft.golden_chestplate": "peto de oro□□en el cuerpo:□armadura: +5",
  "item.minecraft.golden_leggings": "grebas de oro□□en las piernas:□armadura: +3",
  "item.minecraft.golden_boots": "botas de oro□□en los pies:□armadura: +1",
  "item.minecraft.netherite_helmet": "casco de netherita□□en la cabeza:□armadura: +3□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.netherite_chestplate": "peto de netherita□□en el cuerpo:□armadura: +8□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.netherite_leggings": "grebas de netherita□□en las piernas:□armadura: +6□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.netherite_boots": "botas de netherita□□en los pies:□armadura: +3□dureza de armadura: +3□resistencia al empuje: +1",
  "item.minecraft.flint": "pedernal",
  "item.minecraft.porkchop": "chuleta de cerdo cruda",
  "item.minecraft.cooked_porkchop": "chuleta de cerdo cocinada",
  "item.minecraft.painting": "cuadro",
  "item.minecraft.golden_apple": "manzana dorada",
  "item.minecraft.enchanted_golden_apple": "manzana dorada encantada",
  "block.minecraft.oak_sign": "cartel de roble",
  "block.minecraft.spruce_sign": "cartel de abeto",
  "block.minecraft.birch_sign": "cartel de abedul",
  "block.minecraft.jungle_sign": "cartel de jungla",
  "block.minecraft.acacia_sign": "cartel de acacia",
  "block.minecraft.dark_oak_sign": "cartel de roble oscuro",
  "block.minecraft.crimson_sign": "cartel carmesí",
  "block.minecraft.warped_sign": "cartel distorsionado",
  "item.minecraft.bucket": "cubo",
  "item.minecraft.water_bucket": "cubo con agua",
  "item.minecraft.lava_bucket": "cubo con lava",
  "item.minecraft.minecart": "vagoneta",
  "item.minecraft.saddle": "montura",
  "item.minecraft.redstone": "polvo de redstone",
  "item.minecraft.snowball": "bola de nieve",
  "item.minecraft.oak_boat": "barca de roble",
  "item.minecraft.leather": "cuero",
  "item.minecraft.milk_bucket": "cubo con leche",
  "item.minecraft.pufferfish_bucket": "cubo con pez globo",
  "item.minecraft.salmon_bucket": "cubo con salmón",
  "item.minecraft.cod_bucket": "cubo con bacalao",
  "item.minecraft.tropical_fish_bucket": "cubo con pez tropical",
  "item.minecraft.brick": "ladrillo",
  "item.minecraft.clay_ball": "bola de arcilla",
  "block.minecraft.dried_kelp_block": "bloque de algas secas",
  "item.minecraft.paper": "papel",
  "item.minecraft.book": "libro",
  "item.minecraft.slime_ball": "bola de slime",
  "item.minecraft.chest_minecart": "vagoneta con cofre",
  "item.minecraft.furnace_minecart": "vagoneta con horno",
  "item.minecraft.egg": "huevo",
  "item.minecraft.compass": "brújula",
  "item.minecraft.fishing_rod": "caña de pescar",
  "item.minecraft.clock": "reloj",
  "item.minecraft.glowstone_dust": "polvo de piedra luminosa",
  "item.minecraft.cod": "bacalao crudo",
  "item.minecraft.salmon": "salmón crudo",
  "item.minecraft.tropical_fish": "pez tropical",
  "item.minecraft.pufferfish": "pez globo",
  "item.minecraft.cooked_cod": "bacalao cocinado",
  "item.minecraft.cooked_salmon": "salmón ahumado",
  "item.minecraft.ink_sac": "saco de tinta",
  "item.minecraft.red_dye": "tinte rojo",
  "item.minecraft.green_dye": "tinte verde",
  "item.minecraft.cocoa_beans": "semillas de cacao",
  "item.minecraft.lapis_lazuli": "lapislázuli",
  "item.minecraft.purple_dye": "tinte morado",
  "item.minecraft.cyan_dye": "tinte cian",
  "item.minecraft.light_gray_dye": "tinte gris claro",
  "item.minecraft.gray_dye": "tinte gris",
  "item.minecraft.pink_dye": "tinte rosa",
  "item.minecraft.lime_dye": "tinte verde lima",
  "item.minecraft.yellow_dye": "tinte amarillo",
  "item.minecraft.light_blue_dye": "tinte azul claro",
  "item.minecraft.magenta_dye": "tinte magenta",
  "item.minecraft.orange_dye": "tinte naranja",
  "item.minecraft.bone_meal": "polvo de hueso",
  "item.minecraft.blue_dye": "tinte azul",
  "item.minecraft.brown_dye": "tinte marrón",
  "item.minecraft.black_dye": "tinte negro",
  "item.minecraft.white_dye": "tinte blanco",
  "item.minecraft.bone": "hueso",
  "item.minecraft.sugar": "azúcar",
  "block.minecraft.cake": "tarta",
  "block.minecraft.white_bed": "cama blanca",
  "block.minecraft.orange_bed": "cama naranja",
  "block.minecraft.magenta_bed": "cama magenta",
  "block.minecraft.light_blue_bed": "cama azul claro",
  "block.minecraft.yellow_bed": "cama amarilla",
  "block.minecraft.lime_bed": "cama verde lima",
  "block.minecraft.pink_bed": "cama rosa",
  "block.minecraft.gray_bed": "cama gris",
  "block.minecraft.light_gray_bed": "cama gris claro",
  "block.minecraft.cyan_bed": "cama cian",
  "block.minecraft.purple_bed": "cama morada",
  "block.minecraft.blue_bed": "cama azul",
  "block.minecraft.brown_bed": "cama marrón",
  "block.minecraft.green_bed": "cama verde",
  "block.minecraft.red_bed": "cama roja",
  "block.minecraft.black_bed": "cama negra",
  "item.minecraft.cookie": "galleta",
  "item.minecraft.filled_map": "mapa□#0",
  "item.minecraft.shears": "tijeras",
  "item.minecraft.melon_slice": "rodaja de sandía",
  "item.minecraft.dried_kelp": "algas secas",
  "item.minecraft.pumpkin_seeds": "semillas de calabaza",
  "item.minecraft.melon_seeds": "semillas de sandía",
  "item.minecraft.beef": "filete crudo",
  "item.minecraft.cooked_beef": "filete asado",
  "item.minecraft.chicken": "pollo crudo",
  "item.minecraft.cooked_chicken": "pollo asado",
  "item.minecraft.rotten_flesh": "carne podrida",
  "item.minecraft.ender_pearl": "perla de ender",
  "item.minecraft.blaze_rod": "vara de blaze",
  "item.minecraft.ghast_tear": "lágrima de ghast",
  "item.minecraft.gold_nugget": "pepita de oro",
  "item.minecraft.nether_wart": "verruga del nether",
  "item.minecraft.potion": "poción no fabricable□sin efectos",
  "item.minecraft.glass_bottle": "frasco de cristal",
  "item.minecraft.spider_eye": "ojo de araña",
  "item.minecraft.fermented_spider_eye": "ojo de araña fermentado",
  "item.minecraft.blaze_powder": "polvo de blaze",
  "item.minecraft.magma_cream": "crema de magma",
  "block.minecraft.brewing_stand": "soporte para pociones",
  "block.minecraft.cauldron": "caldero",
  "item.minecraft.ender_eye": "ojo de ender",
  "item.minecraft.glistering_melon_slice": "rodaja de sandía reluciente",
  "item.minecraft.bat_spawn_egg": "generar murciélago",
  "item.minecraft.bee_spawn_egg": "generar abeja",
  "item.minecraft.blaze_spawn_egg": "generar blaze",
  "item.minecraft.cat_spawn_egg": "generar gato",
  "item.minecraft.cave_spider_spawn_egg": "generar araña de cueva",
  "item.minecraft.chicken_spawn_egg": "generar pollo",
  "item.minecraft.cod_spawn_egg": "generar bacalao",
  "item.minecraft.cow_spawn_egg": "generar vaca",
  "item.minecraft.creeper_spawn_egg": "generar creeper",
  "item.minecraft.dolphin_spawn_egg": "generar delfín",
  "item.minecraft.donkey_spawn_egg": "generar burro",
  "item.minecraft.drowned_spawn_egg": "generar ahogado",
  "item.minecraft.elder_guardian_spawn_egg": "generar guardián anciano",
  "item.minecraft.enderman_spawn_egg": "generar enderman",
  "item.minecraft.endermite_spawn_egg": "generar endermite",
  "item.minecraft.evoker_spawn_egg": "generar invocador",
  "item.minecraft.fox_spawn_egg": "generar zorro",
  "item.minecraft.ghast_spawn_egg": "generar ghast",
  "item.minecraft.guardian_spawn_egg": "generar guardián",
  "item.minecraft.hoglin_spawn_egg": "generar hoglin",
  "item.minecraft.horse_spawn_egg": "generar caballo",
  "item.minecraft.husk_spawn_egg": "generar zombi momificado",
  "item.minecraft.llama_spawn_egg": "generar llama",
  "item.minecraft.magma_cube_spawn_egg": "generar cubo de magma",
  "item.minecraft.mooshroom_spawn_egg": "generar champiñaca",
  "item.minecraft.mule_spawn_egg": "generar mula",
  "item.minecraft.ocelot_spawn_egg": "generar ocelote",
  "item.minecraft.panda_spawn_egg": "generar panda",
  "item.minecraft.parrot_spawn_egg": "generar loro",
  "item.minecraft.phantom_spawn_egg": "generar fantasma",
  "item.minecraft.pig_spawn_egg": "generar cerdo",
  "item.minecraft.piglin_spawn_egg": "generar piglin",
  "item.minecraft.pillager_spawn_egg": "generar saqueador",
  "item.minecraft.polar_bear_spawn_egg": "generar oso polar",
  "item.minecraft.pufferfish_spawn_egg": "generar pez globo",
  "item.minecraft.rabbit_spawn_egg": "generar conejo",
  "item.minecraft.ravager_spawn_egg": "generar devastador",
  "item.minecraft.salmon_spawn_egg": "generar salmón",
  "item.minecraft.sheep_spawn_egg": "generar oveja",
  "item.minecraft.shulker_spawn_egg": "generar shulker",
  "item.minecraft.silverfish_spawn_egg": "generar lepisma",
  "item.minecraft.skeleton_spawn_egg": "generar esqueleto",
  "item.minecraft.skeleton_horse_spawn_egg": "generar caballo esqueleto",
  "item.minecraft.slime_spawn_egg": "generar slime",
  "item.minecraft.spider_spawn_egg": "generar araña",
  "item.minecraft.squid_spawn_egg": "generar calamar",
  "item.minecraft.stray_spawn_egg": "generar esqueleto glacial",
  "item.minecraft.strider_spawn_egg": "generar lavagante",
  "item.minecraft.trader_llama_spawn_egg": "generar llama ambulante",
  "item.minecraft.tropical_fish_spawn_egg": "generar pez tropical",
  "item.minecraft.turtle_spawn_egg": "generar tortuga",
  "item.minecraft.vex_spawn_egg": "generar vex",
  "item.minecraft.villager_spawn_egg": "generar aldeano",
  "item.minecraft.vindicator_spawn_egg": "generar vindicador",
  "item.minecraft.wandering_trader_spawn_egg": "generar vendedor ambulante",
  "item.minecraft.witch_spawn_egg": "generar bruja",
  "item.minecraft.wither_skeleton_spawn_egg": "generar esqueleto wither",
  "item.minecraft.wolf_spawn_egg": "generar lobo",
  "item.minecraft.zoglin_spawn_egg": "generar zoglin",
  "item.minecraft.zombie_spawn_egg": "generar zombi",
  "item.minecraft.zombie_horse_spawn_egg": "generar caballo zombi",
  "item.minecraft.zombie_villager_spawn_egg": "generar aldeano zombi",
  "item.minecraft.zombified_piglin_spawn_egg": "generar piglin zombificado",
  "item.minecraft.experience_bottle": "frasco con experiencia",
  "item.minecraft.fire_charge": "carga ígnea",
  "item.minecraft.writable_book": "libro y pluma",
  "item.minecraft.written_book": "libro escrito",
  "item.minecraft.emerald": "esmeralda",
  "item.minecraft.item_frame": "marco",
  "block.minecraft.flower_pot": "maceta",
  "item.minecraft.carrot": "zanahoria",
  "item.minecraft.potato": "patata",
  "item.minecraft.baked_potato": "patata cocida",
  "item.minecraft.poisonous_potato": "patata venenosa",
  "item.minecraft.map": "mapa en blanco",
  "item.minecraft.golden_carrot": "zanahoria dorada",
  "block.minecraft.skeleton_skull": "calavera de esqueleto",
  "block.minecraft.wither_skeleton_skull": "calavera de esqueleto wither",
  "block.minecraft.player_head": "cabeza de jugador",
  "block.minecraft.zombie_head": "cabeza de zombi",
  "block.minecraft.creeper_head": "cabeza de creeper",
  "block.minecraft.dragon_head": "cabeza de dragón",
  "item.minecraft.carrot_on_a_stick": "caña con zanahoria",
  "item.minecraft.warped_fungus_on_a_stick": "caña con hongo distorsionado",
  "item.minecraft.nether_star": "estrella del nether",
  "item.minecraft.pumpkin_pie": "tarta de calabaza",
  "item.minecraft.firework_rocket": "cohete de fuegos artificiales",
  "item.minecraft.firework_star": "estrella de fuegos artificiales",
  "item.minecraft.enchanted_book": "libro encantado",
  "item.minecraft.nether_brick": "ladrillo del nether",
  "item.minecraft.quartz": "cuarzo del nether",
  "item.minecraft.tnt_minecart": "vagoneta con dinamita",
  "item.minecraft.hopper_minecart": "vagoneta con tolva",
  "item.minecraft.prismarine_shard": "fragmento de prismarina",
  "item.minecraft.prismarine_crystals": "cristales de prismarina",
  "item.minecraft.rabbit": "conejo crudo",
  "item.minecraft.cooked_rabbit": "conejo asado",
  "item.minecraft.rabbit_stew": "estofado de conejo",
  "item.minecraft.rabbit_foot": "pata de conejo",
  "item.minecraft.rabbit_hide": "piel de conejo",
  "item.minecraft.armor_stand": "soporte para armadura",
  "item.minecraft.iron_horse_armor": "armadura de hierro para caballo",
  "item.minecraft.golden_horse_armor": "armadura de oro para caballo",
  "item.minecraft.diamond_horse_armor": "armadura de diamante para caballo",
  "item.minecraft.leather_horse_armor": "armadura de cuero para caballo",
  "item.minecraft.lead": "rienda",
  "item.minecraft.name_tag": "etiqueta",
  "item.minecraft.command_block_minecart": "vagoneta con bloque de comandos",
  "item.minecraft.mutton": "cordero crudo",
  "item.minecraft.cooked_mutton": "cordero asado",
  "block.minecraft.white_banner": "estandarte blanco",
  "block.minecraft.orange_banner": "estandarte naranja",
  "block.minecraft.magenta_banner": "estandarte magenta",
  "block.minecraft.light_blue_banner": "estandarte azul claro",
  "block.minecraft.yellow_banner": "estandarte amarillo",
  "block.minecraft.lime_banner": "estandarte verde lima",
  "block.minecraft.pink_banner": "estandarte rosa",
  "block.minecraft.gray_banner": "estandarte gris",
  "block.minecraft.light_gray_banner": "estandarte gris claro",
  "block.minecraft.cyan_banner": "estandarte cian",
  "block.minecraft.purple_banner": "estandarte morado",
  "block.minecraft.blue_banner": "estandarte azul",
  "block.minecraft.brown_banner": "estandarte marrón",
  "block.minecraft.green_banner": "estandarte verde",
  "block.minecraft.red_banner": "estandarte rojo",
  "block.minecraft.black_banner": "estandarte negro",
  "item.minecraft.end_crystal": "cristal del end",
  "item.minecraft.chorus_fruit": "fruta coral",
  "item.minecraft.popped_chorus_fruit": "fruta coral horneada",
  "item.minecraft.beetroot": "remolacha",
  "item.minecraft.beetroot_seeds": "semillas de remolacha",
  "item.minecraft.beetroot_soup": "estofado de remolacha",
  "item.minecraft.dragon_breath": "aliento de dragón",
  "item.minecraft.splash_potion": "poción arrojadiza no fabricable□sin efectos",
  "item.minecraft.spectral_arrow": "flecha espectral",
  "item.minecraft.tipped_arrow": "flecha con efecto no fabricable□sin efectos",
  "item.minecraft.lingering_potion": "poción persistente no fabricable□sin efectos",
  "item.minecraft.shield": "escudo",
  "item.minecraft.elytra": "élitros",
  "item.minecraft.spruce_boat": "barca de abeto",
  "item.minecraft.birch_boat": "barca de abedul",
  "item.minecraft.jungle_boat": "barca de jungla",
  "item.minecraft.acacia_boat": "barca de acacia",
  "item.minecraft.dark_oak_boat": "barca de roble oscuro",
  "item.minecraft.totem_of_undying": "tótem de inmortalidad",
  "item.minecraft.shulker_shell": "caparazón de shulker",
  "item.minecraft.iron_nugget": "pepita de hierro",
  "item.minecraft.knowledge_book": "enciclopedia",
  "item.minecraft.debug_stick": "palo de desarrollo",
  "item.minecraft.music_disc_13": "disco de música□c418 - 13",
  "item.minecraft.music_disc_cat": "disco de música□c418 - cat",
  "item.minecraft.music_disc_blocks": "disco de música□c418 - blocks",
  "item.minecraft.music_disc_chirp": "disco de música□c418 - chirp",
  "item.minecraft.music_disc_far": "disco de música□c418 - far",
  "item.minecraft.music_disc_mall": "disco de música□c418 - mall",
  "item.minecraft.music_disc_mellohi": "disco de música□c418 - mellohi",
  "item.minecraft.music_disc_stal": "disco de música□c418 - stal",
  "item.minecraft.music_disc_strad": "disco de música□c418 - strad",
  "item.minecraft.music_disc_ward": "disco de música□c418 - ward",
  "item.minecraft.music_disc_11": "disco de música□c418 - 11",
  "item.minecraft.music_disc_wait": "disco de música□c418 - wait",
  "item.minecraft.music_disc_pigstep": "disco de música□lena raine - pigstep",
  "item.minecraft.trident": "tridente□□en la mano principal:□daño de ataque: +8□velocidad de ataque: -2.9",
  "item.minecraft.phantom_membrane": "membrana de fantasma",
  "item.minecraft.nautilus_shell": "caparazón de nautilo",
  "item.minecraft.heart_of_the_sea": "corazón del mar",
  "item.minecraft.crossbow": "ballesta",
  "item.minecraft.suspicious_stew": "estofado sospechoso",
  "block.minecraft.loom": "telar",
  "item.minecraft.flower_banner_pattern": "diseño de estandarte□estampado de flor",
  "item.minecraft.creeper_banner_pattern": "diseño de estandarte□estampado de creeper",
  "item.minecraft.skull_banner_pattern": "diseño de estandarte□estampado de calavera",
  "item.minecraft.mojang_banner_pattern": "diseño de estandarte□estampado de mojang",
  "item.minecraft.globe_banner_pattern": "diseño de estandarte□estampado de planeta",
  "item.minecraft.piglin_banner_pattern": "diseño de estandarte□estampado de hocico",
  "block.minecraft.composter": "compostador",
  "block.minecraft.barrel": "barril",
  "block.minecraft.smoker": "ahumador",
  "block.minecraft.blast_furnace": "alto horno",
  "block.minecraft.cartography_table": "mesa de cartografía",
  "block.minecraft.fletching_table": "mesa de flechas",
  "block.minecraft.grindstone": "afiladora",
  "block.minecraft.lectern": "atril",
  "block.minecraft.smithing_table": "mesa de herrería",
  "block.minecraft.stonecutter": "cortapiedras",
  "block.minecraft.bell": "campana",
  "block.minecraft.lantern": "farol",
  "block.minecraft.soul_lantern": "farol de almas",
  "item.minecraft.sweet_berries": "bayas dulces",
  "block.minecraft.campfire": "hoguera",
  "block.minecraft.soul_campfire": "hoguera de almas",
  "block.minecraft.shroomlight": "brillongo",
  "item.minecraft.honeycomb": "panal",
  "block.minecraft.bee_nest": "colmena",
  "block.minecraft.beehive": "apiario",
  "item.minecraft.honey_bottle": "frasco con miel",
  "block.minecraft.honey_block": "bloque de miel",
  "block.minecraft.honeycomb_block": "bloque de panal",
  "block.minecraft.lodestone": "magnetita",
  "block.minecraft.netherite_block": "bloque de netherita",
  "block.minecraft.ancient_debris": "escombros ancestrales",
  "block.minecraft.target": "diana",
  "block.minecraft.crying_obsidian": "obsidiana llorosa",
  "block.minecraft.blackstone": "piedra negra",
  "block.minecraft.blackstone_slab": "losa de piedra negra",
  "block.minecraft.blackstone_stairs": "escaleras de piedra negra",
  "block.minecraft.gilded_blackstone": "piedra negra áurea",
  "block.minecraft.polished_blackstone": "piedra negra pulida",
  "block.minecraft.polished_blackstone_slab": "losa de piedra negra pulida",
  "block.minecraft.polished_blackstone_stairs": "escaleras de piedra negra pulida",
  "block.minecraft.chiseled_polished_blackstone": "piedra negra pulida cincelada",
  "block.minecraft.polished_blackstone_bricks": "ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_slab": "losa de ladrillos de piedra negra pulida",
  "block.minecraft.polished_blackstone_brick_stairs": "escaleras de ladrillos de piedra negra pulida",
  "block.minecraft.cracked_polished_blackstone_bricks": "ladrillos de piedra negra pulida agrietados",
  "block.minecraft.respawn_anchor": "nexo de reaparición",
}
export const es_es = items; 
